export default "__VITE_ASSET__WTB41uoi__"